import axios from 'axios';

// AI customer-insert tab — thin axios thunks over /api/ai-insert

export const getAiInsertContext = () => async () => {
  const res = await axios.get('/api/ai-insert/context');
  return res.data;
};

export const aiFetchGroup = (params) => async () => {
  const res = await axios.post('/api/ai-insert/fetch-group', params);
  return res.data;
};

export const aiAnalyzeChat = (chatId) => async () => {
  const res = await axios.post('/api/ai-insert/analyze', { chat_id: chatId });
  return res.data;
};

export const getAiEvents = (after) => async () => {
  const res = await axios.get('/api/ai-insert/events', { params: { after } });
  return res.data;
};

export const aiSendMessage = (text) => async () => {
  const res = await axios.post('/api/ai-insert/message', { text });
  return res.data;
};

export const aiAnswer = (payload) => async () => {
  const res = await axios.post('/api/ai-insert/answer', payload);
  return res.data;
};

export const aiInterrupt = () => async () => {
  const res = await axios.post('/api/ai-insert/interrupt');
  return res.data;
};

export const aiInsertCard = (cardId, card) => async () => {
  const res = await axios.post('/api/ai-insert/card', { card_id: cardId, card });
  return res.data;
};

export const aiResultAction = (resultId, button, rowId) => async () => {
  const res = await axios.post('/api/ai-insert/result-action', { result_id: resultId, button, row_id: rowId });
  return res.data;
};

export const aiDismissCard = (cardId) => async () => {
  const res = await axios.post('/api/ai-insert/dismiss-card', { card_id: cardId });
  return res.data;
};

export const aiSaveDefaults = (defaults) => async () => {
  const res = await axios.post('/api/ai-insert/defaults', defaults);
  return res.data;
};

export const aiClaudeStatus = () => async () => {
  const res = await axios.get('/api/ai-insert/claude/status');
  return res.data;
};

export const aiClaudeLogin = () => async () => {
  const res = await axios.post('/api/ai-insert/claude/login');
  return res.data;
};

export const aiClaudeCode = (code) => async () => {
  const res = await axios.post('/api/ai-insert/claude/code', { code });
  return res.data;
};

export const aiClaudeToken = (token) => async () => {
  const res = await axios.post('/api/ai-insert/claude/token', { token });
  return res.data;
};
